import cornerDotTypes from "../../../constants/cornerDotTypes";
import { CornerDotType, RotateFigureArgs, BasicFigureDrawArgs, DrawArgs } from "../../../types";

/**
 * Worker-safe QR corner dot renderer — produces SVG markup strings instead of DOM elements.
 */
export default class QRCornerDot {
  _svgString: string = "";
  _type: CornerDotType;

  constructor({ type }: { svg?: unknown; type: CornerDotType }) {
    this._type = type;
  }

  draw(x: number, y: number, size: number, rotation: number): void {
    const type = this._type;
    let drawFunction;

    switch (type) {
      case cornerDotTypes.square:
        drawFunction = this._drawSquare;
        break;
      case cornerDotTypes.dot:
      default:
        drawFunction = this._drawDot;
    }

    drawFunction.call(this, { x, y, size, rotation });
  }

  _rotateFigure({ x, y, size, rotation = 0, draw }: RotateFigureArgs): void {
    const cx = x + size / 2;
    const cy = y + size / 2;

    draw();
    if (rotation !== 0 && this._svgString) {
      const transformAttr = ` transform="rotate(${(180 * rotation) / Math.PI},${cx},${cy})"`;
      if (this._svgString.endsWith("/>")) {
        this._svgString = this._svgString.slice(0, -2) + transformAttr + "/>";
      } else {
        const firstClose = this._svgString.indexOf(">");
        if (firstClose > 0) {
          this._svgString =
            this._svgString.slice(0, firstClose) + transformAttr + this._svgString.slice(firstClose);
        }
      }
    }
  }

  _basicDot(args: BasicFigureDrawArgs): void {
    const { size, x, y } = args;

    this._rotateFigure({
      ...args,
      draw: () => {
        this._svgString = `<circle cx="${x + size / 2}" cy="${y + size / 2}" r="${size / 2}"/>`;
      }
    });
  }

  _basicSquare(args: BasicFigureDrawArgs): void {
    const { size, x, y } = args;

    this._rotateFigure({
      ...args,
      draw: () => {
        this._svgString = `<rect x="${x}" y="${y}" width="${size}" height="${size}"/>`;
      }
    });
  }

  _drawDot({ x, y, size, rotation }: DrawArgs): void {
    this._basicDot({ x, y, size, rotation });
  }

  _drawSquare({ x, y, size, rotation }: DrawArgs): void {
    this._basicSquare({ x, y, size, rotation });
  }
}
